module.exports = __webpack_public_path__ + "media/images/sp_menu_icon-077f2fa3e3fe218b10ef1d5d46245f01.svg";